var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightAngle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.47 1.716a.75.75 0 0 0 0 1.06l4.969 4.97-4.97 4.968a.75.75 0 0 0 1.061 1.061l5.323-5.323a1 1 0 0 0 0-1.414L6.53 1.716a.75.75 0 0 0-1.06 0",
  clipRule: "evenodd"
})));
export default SvgRightAngle;